import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";


const Programming = () => {

    const [t] = useTranslation("routes")

    const bread = [
        {name: t("labels.alerts"), url: "/alerts/", current: false},
        {name: t("labels.Programming"), current: true}
    ]

    useEffect(() => {

    }, []);


    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <h1>Programming alert</h1>
        </>
    )
}
export default Programming;